export default __webpack_public_path__ + "static/media/multipack.0abf5b7a.jpg";